import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { initializeTracking } from '@/app/[locale]/app-api/usertracking/user-information';
import { generateFingerprint } from '@/utils/Fingerprint';

export const useParaphraser = () => {
  const intl = useIntl();

  const placeholderText = intl.formatMessage({
    id: 'home.text-Paraphraser.placeholder',
    defaultMessage:
      'Um Text umzuschreiben, geben Sie ihn hier ein oder fügen Sie ihn ein und drücken Sie \"Umschreiben.\"'
  });
  useEffect(() => {
    const setupTracking = async () => {
      const toolName = 'paraphraserLimit';
      const { fingerprint } = await generateFingerprint(); // Use the existing fingerprint generation
      setFingerPrint(fingerprint);
      await initializeTracking(fingerprint, toolName, setCounter); // Initialize tracking with the fingerprint
    };

    setupTracking();
  }, []);

  const [inputText, setInputText] = useState('');
  const [tone, setTone] = useState('same');
  const [length, setLength] = useState('same');
  const [language, setLanguage] = useState('same'); // Language of the website
  const [loading, setLoading] = useState(false);
  const [premium, setPremium] = useState(false); // New premium state
  const [responses, setResponses] = useState<string[]>([]); // List of completed responses
  const [streamingResponse, setStreamingResponse] = useState(''); // Temporary streaming response
  const [isStreaming, setIsStreaming] = useState(false); // Track if streaming is in progress
  const [counter, setCounter] = useState(3); // Initial counter value
  const [isTouched, setIsTouched] = useState(false);
  const [showAd, setShowAd] = useState(!premium);
  const [showDropdown, setShowDropdown] = useState(false);
  const [fingerPrint, setFingerPrint] = useState('');

  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  return {
    placeholderText,
    inputText,
    setInputText,
    tone,
    setTone,
    length,
    setLength,
    language,
    setLanguage,
    fingerPrint,
    setFingerPrint,
    loading,
    setLoading,
    premium,
    setPremium,
    responses,
    setResponses,
    streamingResponse,
    setStreamingResponse,
    isStreaming,
    setIsStreaming,
    counter,
    setCounter,
    isTouched,
    setIsTouched,
    showAd,
    setShowAd,
    showDropdown,
    setShowDropdown,
    inputRef
  };
};
